import React from 'react';
import { images } from '../assets/images';
import Advantages from '../components/Advantages';
import ContactUs from '../components/ContactUs';
import CTA from '../components/CTA';
import FeaturedSection from '../components/FeaturedSection';
import './ATM.css';

function ATM() {
  return (
    <div className="ATM">
      <div className='ATM_hero'>
        <div className='column-left'>
        <h1 className='title'>The software&nbsp;suite<br className="full-width-breakpoint"/> for <strong>retail</strong> points&nbsp;of&nbsp;sale</h1>
        <p className='align-left'>Our solution enables physical points of sale to sell digital products and public services.</p>
        </div>
        <div className='column-right'>
        <img src={images.ATM}/>
        </div>
      </div>
      <section className='function'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Digital Services</h2>
          <p>Thanks to the Dashboard, vending operators can monitor both cash and cashless purchases, analyse machines’ performances, start marketing initiatives, and manage support requests.</p>
        </div>
      </section>
      <section className='function'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Cash deposit and withdrawal</h2>
          <p>Thanks to the Dashboard, vending operators can monitor both cash and cashless purchases, analyse machines’ performances, start marketing initiatives, and manage support requests.</p>
        </div>
      </section>
      <section className='function'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Public services for citizens</h2>
          <p>Thanks to the Dashboard, vending operators can monitor both cash and cashless purchases, analyse machines’ performances, start marketing initiatives, and manage support requests.</p>
        </div>
      </section>
      <section className='dashboard'>
        <div className='text'>
          <h2>Remote management and performances monitoring</h2>
          <p>In Time Link enables ATM management companies to remote monitoring and configuration.</p>
          <ul>
            <li>Alerts of technical issues</li>
            <li>Cash counters</li>
            <li>Purchases report</li>
            <li>Cash and cashless events</li>
            <li>Peripherals monitoring</li>
            <li>Remote configuration</li>
            <li>Tax reports</li>
            <li>Remote commands</li>
          </ul>
        </div>
        <div className='imgs'>
          <img id="imgs-1" src={images.deviceoverview}/>
          <img id="imgs-2" src={images.cashstatus}/>
        </div>
      </section>
      <CTA
      title='Join the retail revolution'
      subtitle='We are always open to collaborate and find the best solution for your business. Send us a message and we will contact you as soon as possible.'
      button='Business enquiry'
      ></CTA>
      <Advantages
      title="Why Retail ATMs?"
      img1={images.case}
      img2={images.case}
      img3={images.case}
      text1="New acquisition channel to sell digital services"
      text2="Remote Management of the ATMs network"
      text3="Smaller, cheaper than traditional ATMs"
      ></Advantages>
      <FeaturedSection
      title='Industry 4.0 compliance'
      subtitle='BOXi Vending is compliant with Industry 4.0 fiscal advantages, backed by Italian Ministry of Economy'
      button='Discover more'
      img={images.industria40}></FeaturedSection>
      <ContactUs
      title="Contact us"
      subtitle="We are open to give you further details about BOXi"
      button="Leave a message"
      ></ContactUs>
    </div>
  );
}

export default ATM;
